import { isEqual } from "lodash";
import { NavLink, Route, Switch, Redirect, useParams } from "polyrouter";
import React, { useState } from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { DeviceGroupOverview } from "./DeviceGroupOverview";
import { DeviceGroupPolicies } from "./DeviceGroupPolicies";
import { DeviceGroupSettings } from "../Settings/DeviceGroupSettings";

export type Metric = {
  type: string;
  count: number;
};

export const DeviceGroupDetailsRouter: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [metric, setMetric] = useState<Metric>({ type: "", count: 0 });

  const updateMetric = (newMetric: Metric) => {
    if (!isEqual(newMetric, metric)) {
      setMetric(newMetric);
    }
  };

  const DeviceGroupSettingsRouter: React.FC<{ id: string }> = ({ id }) => {
    return (
      <Switch>
        <Route nest path="/general">
          <DeviceGroupSettings id={id} />
        </Route>
        <Route nest path="/">
          <Redirect nest to="general" />
        </Route>
      </Switch>
    );
  };

  const { Sidebar } = Layout;
  return (
    <Layout
      back={{
        to: "/manage/device-groups",
        title: t("DEVICE_GROUP_other"),
        iconDesc: t("RETURN_TO_DEVICE_GROUPS")
      }}
    >
      <Sidebar>
        {metric.type && (
          <div className="metric mb-4">
            <div className="metric-count">{metric.count}</div>
            <div className="metric-type">{metric.type}</div>
          </div>
        )}
        <ul className="menu router">
          <li>
            <NavLink nest exact to="">
              {t("OVERVIEW")}
            </NavLink>
          </li>
          <li>
            <NavLink nest exact={false} to="/settings">
              {t("SETTINGS")}
            </NavLink>
            <Route nest path="/settings">
              <ul className="menu router sub">
                <li>
                  <NavLink nest exact to="/general">
                    {t("GENERAL")}
                  </NavLink>
                </li>
              </ul>
            </Route>
          </li>
          <li>
            <NavLink nest exact to="/policies">
              {t("POLICIES")}
            </NavLink>
          </li>
        </ul>
      </Sidebar>
      <Switch>
        <Route nest path="/policies">
          <DeviceGroupPolicies id={id} updateMetric={updateMetric} />
        </Route>
        <Route nest path="/settings">
          <DeviceGroupSettingsRouter id={id} />
        </Route>
        <Route nest path="">
          <DeviceGroupOverview id={id} updateMetric={updateMetric} />
        </Route>
      </Switch>
    </Layout>
  );
};
